import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	scroller: 'js-m-stage-keyvisual-carousel__scroller',
	list: 'js-m-stage-keyvisual-carousel__list',
	item: 'js-m-stage-keyvisual-carousel__item',
	falseItem: 'false-item',
	activeItem: 'state-m-stage-keyvisual-carousel--item-is-active',
	activeCaption: 'state-m-stage-keyvisual-carousel--caption-is-active',
	captionWrapper: 'js-m-stage-keyvisual-carousel__caption-wrapper',
	caption: 'js-m-stage-keyvisual-carousel__caption-item',
	dotButton: 'js-m-stage-keyvisual-carousel__dot-button',
	dot: 'js-m-stage-keyvisual-carousel__dot',
	activeDot: 'state-m-stage-keyvisual-carousel--dot-is-active',
	dotWrapper: 'js-m-stage-keyvisual-carousel__dots-wrapper',
	dotArea: 'js-m-stage-keyvisual-carousel__dots',
	showArrow: 'state-m-stage-keyvisual-carousel--arrow-is-shown',
	arrowLeft: 'js-m-stage-keyvisual-carousel__arrow--left',
	arrowRight: 'js-m-stage-keyvisual-carousel__arrow--right',
	link: 'js-m-stage-keyvisual-carousel__item-link',
	pages: 'js-m-stage-keyvisual-carousel__pages',
	currentPage: 'js-m-stage-keyvisual-carousel__current-page',
	totalPage: 'js-m-stage-keyvisual-carousel__total-page',
	videoElement: 'js-m-stage-keyvisual-carousel__video',
	ScrollDownLink: 'js-m-stage-keyvisual-carousel__scroll-down-link',
	pauseplay: 'js-m-stage-keyvisual-carousel__pauseplay',
	arrowPlay: 'js-m-stage-keyvisual-carousel__arrow--play',
	dotItem: 'nav__li-dots',
};

@createModule('StageKeyvisualCarousel')
/**
 * Breadcrumb module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class StageKeyvisualCarousel extends TerrificSpec {
	$ctx: JQuery;
	$dot: JQuery;
	$dotButton: JQuery;
	$dotWrapper: JQuery;
	$dotArea: JQuery;
	$captionWrapper: JQuery;
	$caption: JQuery;
	$arrowLeft: JQuery;
	$arrowRight: JQuery;
	$pauseplay: JQuery;
	$arrowPlay: JQuery;
	$scroller: JQuery;
	$items: JQuery;
	$list: JQuery;
	$links: JQuery;
	$pages: JQuery;
	$currentPage: JQuery;
	$totalPage: JQuery;
	$videoElement: JQuery;
	$ScrollDownLink: JQuery;
	itemsPerPage: Array<number>;
	_sliderKeyVisualPageIndex: number;
	sliderKeyVisualLength: number;
	dotIndex: number;
	currentPage: number;
	leftWidth: number;
	carosuelInterval: number;
	carosuelIntervalInitial: number;
	pageFinalNumber: number = 0;
	$dotItem: JQuery;

	start(resolve: Function) {
		this.initVars();

		$(window).on('resize', () => {
			this.setScrollerHeight();
		});

		this.initScroller();
		this.initNavigationArrows();
		this.setActiveDot(0);
		this.goToDotX(0);
		this.setScrollerHeight();
		this.initDotForMobile();
		this.initLiDotForMobile();
		this.initItemDots();

		setTimeout(() => {
			this.$captionWrapper.height(this.$caption.eq(0).innerHeight());
		}, 50);
		resolve();
	}

	initVars() {
		this.$ctx = $(this._ctx);
		this.$arrowLeft = $(`.${classes.arrowLeft}`, this.$ctx);
		this.$arrowRight = $(`.${classes.arrowRight}`, this.$ctx);

		this.$pauseplay = $(`.${classes.pauseplay}`, this.$ctx);
		this.$arrowPlay = $(`.${classes.arrowPlay}`, this.$ctx);

		this.$scroller = $(`.${classes.scroller}`, this.$ctx);
		this.$items = $(`.${classes.item}`, this.$ctx);
		this.$list = $(`.${classes.list}`, this.$ctx);
		this.$links = $(`.${classes.link}`, this.$ctx);
		this.$pages = $(`.${classes.pages}`, this.$ctx);
		this.$currentPage = $(`.${classes.currentPage}`, this.$ctx);
		this.$totalPage = $(`.${classes.totalPage}`, this.$ctx);
		this.$videoElement = $(`.${classes.videoElement}`, this.$ctx);
		this.$dot = $(`.${classes.dot}`, this.$ctx);
		this.$dotButton = $(`.${classes.dotButton}`, this.$ctx);
		this.$dotWrapper = $(`.${classes.dotWrapper}`, this.$ctx);
		this.$dotArea = $(`.${classes.dotArea}`, this.$ctx);
		this.$captionWrapper = $(`.${classes.captionWrapper}`, this.$ctx);
		this.$caption = $(`.${classes.caption}`, this.$ctx);
		this.$ScrollDownLink = $(`.${classes.ScrollDownLink}`, this.$ctx);
		this.sliderKeyVisualPageIndex = 0;
		this.dotIndex = 0;
		this.sliderKeyVisualLength = this.$items.length;
		this.$dotItem = $(`.${classes.dotItem}`, this.$ctx);
		this.carosuelInterval = parseInt(this.$ctx.data("carousel-interval")) * 1000;
		this.carosuelIntervalInitial = parseInt(this.$ctx.data("carousel-interval"));
		$('.animsvg').css('animation-duration', this.carosuelIntervalInitial + 's');
	}

	initNavigationArrows() {
		// bind event on the left arrow  to go to active page minus 1 (to left)
		this.$arrowLeft.on('click', (e: Event) => {
			clearInterval(interval);
			$('.animsvg').removeClass('showAnim');
			$('.m-toggle-icon').removeClass('circle');
			this.evtClickSkipBackOrForth(e, -1);

			if ($('.js-m-stage-keyvisual-carousel__pauseplay').hasClass('m-stage-keyvisual-carousel__arrow--pause')) {
				setTimeout(() => {
					$('.animsvg').addClass('showAnim');
					$('.m-toggle-icon').addClass('circle');
				}, 200);
				interval = setInterval(function () {
					m.evtClickSkipBackOrForth(null, 1);
					$('.animsvg').removeClass('showAnim');
					$('.m-toggle-icon').removeClass('circle');

					setTimeout(() => {
						$('.animsvg').addClass('showAnim');
						$('.m-toggle-icon').addClass('circle');
					}, 200);
				}, this.carosuelInterval);
			}
		});

		// bind event on the right arrow to go to active page plus 1 (to right)
		this.$arrowRight.on('click', (e: Event) => {
			clearInterval(interval);
			$('.animsvg').removeClass('showAnim');
			$('.m-toggle-icon').removeClass('circle');
			this.evtClickSkipBackOrForth(e, 1);
			if ($('.js-m-stage-keyvisual-carousel__pauseplay').hasClass('m-stage-keyvisual-carousel__arrow--pause')) {
				setTimeout(() => {
					$('.animsvg').addClass('showAnim');
					$('.m-toggle-icon').addClass('circle');
				}, 200);
				interval = setInterval(function () {
					m.evtClickSkipBackOrForth(null, 1);
					$('.animsvg').removeClass('showAnim');
					$('.m-toggle-icon').removeClass('circle');

					setTimeout(() => {
						$('.animsvg').addClass('showAnim');
						$('.m-toggle-icon').addClass('circle');
					}, 200);
				}, this.carosuelInterval);
			}
		});

		var m = this;
		var interval = setInterval(function () {
			m.evtClickSkipBackOrForth(null, 1);
			$('.animsvg').removeClass('showAnim');
			$('.m-toggle-icon').removeClass('circle');

			setTimeout(() => {
				$('.animsvg').addClass('showAnim');
				$('.m-toggle-icon').addClass('circle');
			}, 200);
		}, this.carosuelInterval);

		this.$pauseplay.on('click', (e: Event) => {
			$('.animsvg').toggleClass('showAnim');
			if (
				$('.m-stage-keyvisual-carousel__pauseplay').hasClass(
					'm-stage-keyvisual-carousel__arrow--pause js-m-stage-keyvisual-carousel__arrow--pause'
				)
			) {
				$('.m-toggle-icon').removeClass('circle');
				$('.m-stage-keyvisual-carousel__pauseplay').removeClass(
					'm-stage-keyvisual-carousel__arrow--pause js-m-stage-keyvisual-carousel__arrow--pause'
				);
				$('.m-stage-keyvisual-carousel__pauseplay').addClass(
					'm-stage-keyvisual-carousel__arrow--play js-m-stage-keyvisual-carousel__arrow--play'
				);
				clearInterval(interval);
			} else {
				interval = setInterval(function () {
					m.evtClickSkipBackOrForth(null, 1);
					$('.animsvg').removeClass('showAnim');
					$('.m-toggle-icon').removeClass('circle');

					setTimeout(() => {
						$('.animsvg').addClass('showAnim');
						$('.m-toggle-icon').addClass('circle');
					}, 200);
				}, this.carosuelInterval);
				$('.m-toggle-icon').addClass('circle');
				$('.m-stage-keyvisual-carousel__pauseplay').addClass(
					'm-stage-keyvisual-carousel__arrow--pause js-m-stage-keyvisual-carousel__arrow--pause'
				);
				$('.m-stage-keyvisual-carousel__pauseplay').removeClass(
					'm-stage-keyvisual-carousel__arrow--play js-m-stage-keyvisual-carousel__arrow--play'
				);
			}
		});
	}

	initScroller() {
		//this.initPageDots(0);
		this.goToPageX(0);

		var itemWidth = $(window).width();
		this.$items.width(itemWidth);
		this.$list.append(
			this.$items
				.first()
				.clone()
				.addClass(classes.falseItem)
				.removeClass(classes.activeItem)
				.width(itemWidth)
		);
		this.$list.prepend(
			this.$items
				.last()
				.clone()
				.addClass(classes.falseItem)
				.width(itemWidth)
		);
		this.$totalPage.text(this.sliderKeyVisualLength);
		this.$currentPage.text(1);
		if (this.sliderKeyVisualLength == 3) {
			this.$pages.addClass('pages-pc-hide');
		} else if (this.sliderKeyVisualLength == 2) {
			this.$pages.addClass('pages-mobile-visible');
		} else if (this.sliderKeyVisualLength < 2) {
			this.$pages.hide();
			this.$arrowLeft.parent().hide();
			this.$dotWrapper.parent().hide();
			this.$captionWrapper.addClass('alone');
		}
	}

	// Method to click on dots for navigation
	initItemDots() {
		$('li.nav__li-dots').each((index: number, elem: HTMLElement) => {
			$(elem).on('click', (e: Event) => {
				this.setActiveDot(index);
				this.goToPageX(index);
				this.goToDotX(index);
			});
		});
	}

	initDotForMobile() {
		let $elements = $("div.js-m-stage-keyvisual-carousel__item");
		let startX: any;
		let startY: any;
		let sdeltaX: any;
		let sdeltaY: any;
		let indexItem: number;

		$elements.each((index: number, elem: HTMLElement) => {
			$(elem).on('touchstart', (e: any) => {
				if (e.type == "touchstart") {
					e.stopImmediatePropagation();
					startX = e.originalEvent.touches[0].clientX;
					startY = e.originalEvent.touches[0].clientY;
					indexItem = index - 1;
				}
			});

			$(elem).on('touchend', (e: any) => {
				let newItemIndex: number;
				sdeltaX = Math.ceil(e.originalEvent.changedTouches[0].clientX - startX);
				sdeltaY = Math.ceil(e.originalEvent.changedTouches[0].clientY - startY);
				newItemIndex = sdeltaX < 0 ? index : indexItem === 0 ? this.sliderKeyVisualLength - 1 : indexItem - 1;

				this.setActiveDot(newItemIndex);
				this.goToPageX(newItemIndex);
				this.goToDotX(newItemIndex);
			});
		});
	}

	initLiDotForMobile() {
		let $liElements = $("li.js-m-stage-keyvisual-carousel__dot");
		let startX: any;
		let startY: any;
		let sdeltaX: any;
		let sdeltaY: any;
		let indexItem: number;

		$liElements.each((index: number, elem: HTMLElement) => {
			$(elem).on('touchstart', (e: any) => {
				if (e.type == "touchstart") {
					e.stopImmediatePropagation();
					startX = e.originalEvent.touches[0].clientX;
					startY = e.originalEvent.touches[0].clientY;
					indexItem = index;
				}
			});

			$(elem).on('touchend', (e: any) => {
				let newItemIndex: number;
				sdeltaX = Math.ceil(e.originalEvent.changedTouches[0].clientX - startX);
				sdeltaY = Math.ceil(e.originalEvent.changedTouches[0].clientY - startY);
				newItemIndex = sdeltaX < 0 ? index + 1 : indexItem === 0 ? this.sliderKeyVisualLength - 1 : indexItem - 1;

				this.setActiveDot(newItemIndex);
				this.goToPageX(newItemIndex);
				this.goToDotX(newItemIndex);
			});
		});
	}

	setScrollerHeight() {
		var itemWidth = $(window).width();
		this.$items.width(itemWidth);
		$('.false-item').width(itemWidth);
		this.leftWidth = -(this.sliderKeyVisualPageIndex + 1) * itemWidth;
		this.$captionWrapper.height(140);
	}

	setActiveDot(pageNumber: number) {
		this.$caption
			.removeClass(classes.activeCaption)
			.eq(pageNumber)
			.addClass(classes.activeCaption);

		this.$videoElement.trigger('pause');
		this.$items
			.eq(pageNumber)
			.find('video')
			.trigger('play');

		this.$captionWrapper.height(this.$caption.eq(pageNumber).innerHeight());

		this.$currentPage.text(pageNumber + 1);

		this.$dot
			.removeClass(classes.activeDot)
			.eq(pageNumber)
			.addClass(classes.activeDot);

		var sliderkeyvisuallength = this.sliderKeyVisualLength;
		if (sliderkeyvisuallength < 3) {
			this.$dotArea.addClass('scroll-inactive');
		} else if (sliderkeyvisuallength == 3) {
			this.$dotArea.addClass('scroll-tabet-active');
		} else if (sliderkeyvisuallength > 3) {
			this.$dotArea.addClass('scroll-active');
		}

		this.sliderKeyVisualPageIndex = pageNumber;
	}

	goToPageX(pageNumber: number) {
		this.currentPage = pageNumber;
		var itemPerWidth = 0 - $(window).width();
		var me = this;

		var removeActiveLabelClass = $(
			'.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item.active'
		).attr('data-label-color-class');
		$('span.outer-circle')
			.find('button')
			.removeClass(removeActiveLabelClass);
		$('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item.active')
			.fadeOut()
			.removeClass('active');

		if (pageNumber == 0) {
			$('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:first')
				.addClass('active')
				.fadeIn()
				.end();
			var labelClassColor = $(
				'.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:first'
			).attr('data-label-color-class');
			$('span.outer-circle')
				.find('button')
				.addClass(labelClassColor);
		} else if (pageNumber >= 4) {
			$('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:first')
				.addClass('active')
				.fadeIn()
				.end();
			var labelClassColor = $(
				'.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:first'
			).attr('data-label-color-class');
			$('span.outer-circle')
				.find('button')
				.addClass(labelClassColor);
		} else if (pageNumber < 0) {
			$('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:nth-child(4)')
				.addClass('active')
				.fadeIn()
				.end();
			var labelClassColor = $(
				'.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item:nth-child(4)'
			).attr('data-label-color-class');
			$('span.outer-circle')
				.find('button')
				.addClass(labelClassColor);
		} else {
			$('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item')
				.eq(pageNumber)
				.addClass('active')
				.fadeIn()
				.end();
			var labelClassColor = $('.js-m-stage-keyvisual-carousel__list .js-m-stage-keyvisual-carousel__item')
				.eq(pageNumber)
				.attr('data-label-color-class');
			$('span.outer-circle')
				.find('button')
				.addClass(labelClassColor);
		}

		if (pageNumber < 0) {
			pageNumber = this.sliderKeyVisualLength - 1;
		} else if (pageNumber == this.sliderKeyVisualLength) {
			pageNumber = 0;
		}

		setTimeout(() => {
			$('.false-item').remove();
		}, 500);

		setTimeout(() => {
			$(window).trigger('resize');
		}, 10);

		me.setActiveDot(pageNumber);
		me.sliderKeyVisualPageIndex = pageNumber;
	}

	goToDotX(nextIndex: number) {
		var sliderkeyvisuallength = this.sliderKeyVisualLength;
		this.dotIndex = nextIndex;
		if (sliderkeyvisuallength > 2) {
			if (screen.width < 768) {
				var zeroDot = nextIndex - 1;
				var oneDot = nextIndex;
				var twoDot = nextIndex + 1;
				var threeDot = nextIndex + 2;
				var fourDot = nextIndex - 3;
			} else {
				var zeroDot = nextIndex;
				var oneDot = nextIndex + 1;
				var twoDot = nextIndex + 2;
				var threeDot = nextIndex + 3;
				var fourDot = nextIndex;
			}
			if (oneDot == sliderkeyvisuallength) {
				oneDot = 0;
				twoDot = 1;
				threeDot = 2;
				fourDot = 3;
			} else if (twoDot == sliderkeyvisuallength) {
				twoDot = 0;
				threeDot = 1;
				fourDot = 2;
			} else if (threeDot == sliderkeyvisuallength) {
				threeDot = 0;
				fourDot = 1;
			} else if (fourDot == sliderkeyvisuallength) {
				fourDot = 0;
			} else if (zeroDot == sliderkeyvisuallength) {
				oneDot = 3;
				twoDot = 2;
				threeDot = 1;
				fourDot = 0;
			}
			this.$dot.removeClass('pc-prev-zero pc-next-one pc-next-two pc-next-three pc-next-four');
			$('.nav__li-dots').removeClass('nav__active');

			this.$dot.eq(zeroDot).addClass('pc-prev-zero');
			this.$dot.eq(oneDot).addClass('pc-next-one');
			this.$dot.eq(twoDot).addClass('pc-next-two');
			this.$dot.eq(threeDot).addClass('pc-next-three');
			$('.nav__li-dots')
				.eq(oneDot)
				.addClass('nav__active');
			setTimeout(() => {
				this.$dot.eq(fourDot).addClass('pc-next-four');
			}, 300);
		}
	}
	/**
	 * Click Event for Dots in Slider-Gallery
	 * @param {event} e event
	 * @param {number} index index
	 * @returns {void} return nothing
	 */
	evtClickDot(e: any, index: number) {
		this.goToPageX(index);
	}

	/**
	 * Click Event for Skip Back/Next slider in Slider-Gallery
	 * @param {event} e event
	 * @param {number} sliderIdxOffset Positive integer value will increase and negative will decrease the slider page
	 * @returns {void} return nothing
	 */
	evtClickSkipBackOrForth(e: Event, sliderIdxOffset: number) {
		this.pageFinalNumber = this.dotIndex;
		if (sliderIdxOffset < 0) {
			this.$dotArea.addClass('scroll-left');
			setTimeout(() => {
				if (this.dotIndex == 0) {
					const nextIndex = this.sliderKeyVisualLength - 1;
					setTimeout(() => {
						this.goToDotX(nextIndex);
					}, 50);
				} else {
					const nextIndex = this.dotIndex + sliderIdxOffset;
					this.goToDotX(nextIndex);
				}
			}, 50);
		} else {
			this.$dotArea.removeClass('scroll-left');
			setTimeout(() => {
				if (this.dotIndex == this.sliderKeyVisualLength - 1) {
					const nextIndex = 0;
					this.goToDotX(nextIndex);
				} else {
					const nextIndex = this.dotIndex + sliderIdxOffset;
					this.goToDotX(nextIndex);
				}
			}, 50);
		}
		const nextPage = this.sliderKeyVisualPageIndex + sliderIdxOffset;
		this.goToPageX(nextPage);
	}

	/**
	 * Slider Page Index
	 * @returns {void} return nothing
	 */
	get sliderKeyVisualPageIndex(): number {
		return this._sliderKeyVisualPageIndex;
	}

	/**
	 * Slider Page Index
	 * @param {number} value index
	 * @returns {void} return nothing
	 */
	set sliderKeyVisualPageIndex(value: number) {
		this._sliderKeyVisualPageIndex = value;
	}

	/**
	 * Scroll to top of the document
	 * @returns {void}
	 */

	/**
	 * back-to-top button should contain the 'a-button--anchor' css class that comes from the button modifier 'top'
	 * to separate its click event
	 * @returns {boolean} boolean
	 */

	stop() { }
}
